import React from 'react';
import { useI18n } from '../../contexts/I18nContext';

const STATUS = {
  reporting: 'bg-sage-600 text-white',
  silent: 'bg-terracotta-100 text-terracotta-700',
  never_seen: 'bg-stone-100 text-ink-muted border border-dashed border-stone_line',
  deactivated: 'bg-stone-200 text-ink-soft line-through decoration-1',
};

export function GatewayStatusChip({ status, testid }) {
  const { t } = useI18n();
  return (
    <span data-testid={testid} className={`inline-block text-[10px] uppercase tracking-[0.16em] font-semibold px-2 py-1 rounded-full ${STATUS[status] || STATUS.never_seen}`}>
      {t(`gw_status_${status || 'never_seen'}`)}
    </span>
  );
}
